import React, { useEffect, useRef } from 'react';
import './Story_parselings.css';

import parsePng from '../../../assets/images/parselings/Parse.png';
import parseWebp from '../../../assets/images/parselings/Parse.webp';
import story2png from '../../../assets/images/parselings/story2.png';
import story2Webp from '../../../assets/images/parselings/story2.webp';

const Story = () => {
  const firstSectionRef = useRef(null);
  const secondSectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const section = entry.target;
          const image = section.querySelector('.story_image, .story_image_2');
          const card = section.querySelector('.story_card');
          
          if (section.classList.contains('reverse')) {
            image.classList.add('fade-in-right-image');
            card.classList.add('fade-in-left-card');
          } else {
            image.classList.add('fade-in-left-image');
            card.classList.add('fade-in-right-card');
          }
          
          observer.unobserve(section);
        }
      });
    }, { threshold: 0.3 });

    if (firstSectionRef.current) observer.observe(firstSectionRef.current);
    if (secondSectionRef.current) observer.observe(secondSectionRef.current);

    return () => observer.disconnect();
  }, []);

  return (
    <div className="story_container">
      <div className="story_content">
        {/* First Section */}
        <div className="story_section" ref={firstSectionRef}>
          <div className="story_image">
            <picture>
              <source srcSet={parseWebp} type="image/webp" />
              <img src={parsePng} alt="Parse" />
            </picture>
          </div>
          <div className="story_card">
            <div className="story_highlight">
              <span className="power_word">POWER</span>
              <span className="power_word">IDENTITY</span>
              <span className="power_word">SYMBIOSIS</span>
            </div>
            <div className="story_paragraphs">
              <p>
                <span className="emphasis">Parselings</span> is a modern Deck building RPG about using collaborative word magic and discovering your place in it. The game takes place in a world like our own, but with one major difference – to some, words have literal <span className="emphasis">power</span>.
              </p>
              <p>
                <span className="emphasis">Parsecytes</span>, swarms of ravenous ink-like parasitic organisms, have emerged into the world causing irreversible changes to society and our ecosystem.
              </p>
            </div>
          </div>
        </div>

        {/* Second Section */}
        <div className="story_section reverse" ref={secondSectionRef}>
          <div className="story_image_2">
            <picture>
              <source srcSet={story2Webp} type="image/webp" />
              <img src={story2png} alt="Parse" />
            </picture>
          </div>
          <div className="story_card">
            <div className="story_paragraphs">
              <p>
                When a Parsecyte invades a human host, it forms a <span className="emphasis">symbiosis</span> with them, together becoming an entity known as a <span className="emphasis">Parseling</span>. At a glance, Parselings are indiscernible from most other humans except for the labels on their skin and the ink mixed into their blood. When brought together in groups, these individuals become greater than the sum of their parts. The infected hosts can use their tattoos to form phrases and sculpt the world to their desires. This power has come to be known as a <span className="emphasis">Parse</span>.
              </p>
              <p>
                You will play as one of these beings. Struggling to strike a balance between appeasing the Parsecyte within, and proving you are a complex human being who cannot only be defined by a few careless words. This is both a curse and a blessing, but with the others that share your affliction, the world is your oyster.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Story;